import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';
import { OPTION_GROUP_VARIANTS } from 'dpl/quiz/option_group/utils/constants';

function DeliveryMethodImage({ src }) {
  return (
    <SmartImage
      Tag="div"
      className="self-start br1 cover bg-center"
      src={src}
      height="72px"
      width="72px"
    />
  );
}

DeliveryMethodImage.propTypes = {
  src: PropTypes.string.isRequired
};

export default function QuizDeliveryMethodQuestionMobile({
  availableDeliveryOptions,
  handleNextClick,
  isValid,
  onSubmit
}) {
  return (
    <div className="AdoptionApplicationQuizDeliveryMethodQuestionMobile">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title="How do you want to bring your puppy home?"
        subtitle="Select the transportation options you’re interested in."
        onSubmit={onSubmit}
      >
        <OptionGroup variant={OPTION_GROUP_VARIANTS.LIST}>
          {availableDeliveryOptions.map((option, idx) => (
            <OptionGroupOption
              key={idx}
              isSelected={option.isSelected}
              inputName={option.inputName}
              onSelect={option.onSelect}
              subtitle={option.subtitle}
              title={option.title}
              value={option.value}
              imageComponent={<DeliveryMethodImage src={option.imageSrc} />}
              type="checkbox"
            />
          ))}
        </OptionGroup>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizDeliveryMethodQuestionMobile.propTypes = {
  availableDeliveryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      inputName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      isSelected: PropTypes.bool.isRequired,
      onSelect: PropTypes.func.isRequired,
      imageSrc: PropTypes.string.isRequired
    })
  ).isRequired,
  handleNextClick: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func
};

QuizDeliveryMethodQuestionMobile.defaultProps = {
  onSubmit: null
};
